import { render, staticRenderFns } from "./transaction-actions.vue?vue&type=template&id=8c8fa2d0&scoped=true"
import script from "./transaction-actions.vue?vue&type=script&lang=js"
export * from "./transaction-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8fa2d0",
  null
  
)

export default component.exports